import { useEffect } from 'react';
import { Button, Flex, Text } from '@nula/core-ui';
import { FloatingPanel } from '@/components/floating-panel/floating-panel';
import styles from './suggestion-review-tooltip.module.css';

export interface SuggestionReviewTooltipProps {
  open: boolean;
  anchorRect: DOMRect | null;
  onAccept: () => void;
  onDiscard: () => void;
}

export function SuggestionReviewTooltip({ open, anchorRect, onAccept, onDiscard }: SuggestionReviewTooltipProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Enter') { e.preventDefault(); onAccept(); }
      else if (e.key === 'Escape') { e.preventDefault(); onDiscard(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onAccept, onDiscard]);

  if (!open) return null;

  const top = anchorRect ? anchorRect.bottom + 6 : 0;
  const left = anchorRect ? anchorRect.left : 0;

  return (
    <FloatingPanel top={top} left={left} compact>
      <Flex align="center" gap="sm" className={styles.toolbar}>
        <Button variant="primary" size="sm" onClick={onAccept}>
          {'✓ Accept '}
          <Text className={styles.kbd}>⏎</Text>
        </Button>
        <Button variant="default" size="sm" onClick={onDiscard}>
          {'✕ Discard '}
          <Text className={styles.kbd}>esc</Text>
        </Button>
      </Flex>
    </FloatingPanel>
  );
}
